const emailPattern =
  /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

// with polish signs (before @)
// const emailPattern = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;
const phonePattern = /^\+?[0-9() -]+$/i;
const namePattern = /^[\w'\-,.]*[^_!¡?÷?¿\\+=@#$%ˆ&*(){}|~<>;:[\]]*$/i;
const postalCodePattern = /^[0-9]{2}-[0-9]{3}/i;

const allowedPaymentTypes = [
  'kindergarden_vat_invoice',
  'parent_monthly',
  'parent_by_semester',
  'payment_yearly',
];

export const validate = (value, type) => {
  const string = '' + value;

  if (value === '') {
    return 'start';
  }

  let state;
  switch (type) {
    case 'email':
      state = emailPattern.test(string);
      break;
    case 'phone':
      state = phonePattern.test(string);
      break;
    case 'name':
      state = namePattern.test(string) && value.toString().trim().split(/\s+/).length >= 2;
      break;
    case 'parentFullName':
      state = namePattern.test(string) && value.toString().trim().split(/\s+/).length >= 2;
      break;
    case 'paymentType':
      state =
        value.toString().length > 0 &&
        allowedPaymentTypes.indexOf(value.toString()) > -1;
      break;
    case 'streetAddress':
      state = value.toString().length > 4 && value.toString().length < 200;
      break;
    case 'postalCode':
      state = postalCodePattern.test(string) && value.toString().length > 0;
      break;
    case 'city':
      state = value.toString().length > 2;
      break;
    case 'promoCoupon':
      //TODO add more tests for coupon validity
      state = value.toString().length >= 0 && value.toString().length < 30;
      break;
    case "schoolClass":
      state = value.toString().length < 200;
      break;
    default:
      state = true;
      break;
  }

  return state ? 'success' : 'error';
};
